// ─────────────────────────────────────────────────────────────────────────────
// Entradas del Programa de Reconocimiento, en el orden de la maqueta.
//
// Fuente ÚNICA del bloque "Reconocimientos" del menú (components/layout/Sidebar), que desde T-2
// es el mismo en las dos zonas: navegación SPA dentro de /app (variante `recognition`) y dura
// desde el portal (variante `portal`). Declararlas dos veces las haría divergir en cuanto se
// agregue o renombre una.
//
// `id` es la clave de RECOGNITION_ACCESS (contexts/UserContext) — el gating de ambos menús.
// ─────────────────────────────────────────────────────────────────────────────

export interface RecognitionNavLink {
  id: string;
  to: string;
  icon?: string;
  iconClass?: string;
  emoji?: string;
  /** Clave del espacio de nombres i18n `recognition`. */
  labelKey: string;
}

/** Clases del glifo de una entrada. Sin anidar plantillas: Sonar lo marca como bloqueante. */
export function recognitionIconClass({ icon, iconClass }: RecognitionNavLink): string {
  return iconClass ? `fas ${icon} ${iconClass}` : `fas ${icon}`;
}

/**
 * RF-074 / WP-B2 — la ÚNICA entrada que una campaña puede renombrar.
 *
 * Va como constante y no como una comparación con la cadena `'innovacion'` repartida por el código:
 * cuando alguien renombre la ruta, el menú tiene que seguir sabiendo cuál es la personalizable. Las
 * demás entradas son identidad de la plataforma y ninguna campaña las gobierna (REQ-034).
 */
export const CAMPAIGN_NAV_ID = 'innovacion';

/**
 * Reconocer, Brillamos y la campaña personalizada son mutuamente excluyentes: el backend nunca
 * deja más de una campaña `Activa` por OU (`CampaignRepository.GetActiveByOuAsync`), así que el
 * menú tiene que reflejar esa misma exclusividad y mostrar solo la entrada que corresponde — nunca
 * las tres a la vez. `perfil` queda fuera a propósito: no es una campaña, se rige solo por rol.
 * Ver `useActiveRecognitionEntryId` (useCampaignNavEntry.ts), que resuelve cuál de las tres aplica.
 */
export const EXCLUSIVE_RECOGNITION_NAV_IDS: readonly string[] = ['reconocer', 'brillamos', CAMPAIGN_NAV_ID];

export const RECOGNITION_NAV_LINKS: RecognitionNavLink[] = [
  { id: 'reconocer',     to: '/app/reconocer',     icon: 'fa-trophy',      labelKey: 'nav.recognize' },
  { id: 'brillamos',     to: '/app/brillamos',     icon: 'fa-star',        labelKey: 'nav.shine', iconClass: 'side-star-shine' },
  { id: 'perfil',        to: '/app/perfil',        icon: 'fa-user-circle', labelKey: 'nav.profile' },
  { id: 'innovacion',    to: '/app/innovacion',    emoji: '🚀',            labelKey: 'nav.innovation' },
];
